import { Box, LinearProgress, styled, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import * as React from "react";

export interface TableCellProgressBarCellProps {
  progress: number;
  subtitle?: string;
}

const TableCellProgressBar: React.FC<TableCellProgressBarCellProps> = ({ progress, subtitle }) => {
  const percentage: string = Math.round(progress).toString() + "%";
  return (
    <>
      {progress ? (
        <Stack>
          <Stack direction="row" alignItems="center">
            <Typography
              fontWeight={500}
              mr={1}
              color={progress > 50 ? "success.main" : "error.main"}
              sx={{ wordBreak: "keep-all" }}
            >
              {percentage}
            </Typography>
            <Box width="100%" sx={{ minWidth: "80px" }}>
              <CustomLinearProgress variant="determinate" value={progress} sx={{ borderRadius: "1px" }} />
            </Box>
          </Stack>
          <Typography variant="body2" color="text.tier">
            {subtitle}
          </Typography>
        </Stack>
      ) : (
        "-"
      )}
    </>
  );
};

export default TableCellProgressBar;

const CustomLinearProgress = styled(LinearProgress)(({ theme, value }) => ({
  ...(value! > 50
    ? {
        background: theme.palette.background.default,
        position: "relative",
        "&::after": {
          zIndex: -1,
          content: "''",
          position: "absolute",
          width: "100%",
          height: "100%",
          background: theme.palette.backgroundAlpha.main,
        },
        ".MuiLinearProgress-bar": {
          background: theme.palette.success.main,
        },
      }
    : {
        background: theme.palette.error.main,
        ".MuiLinearProgress-bar": {
          background: theme.palette.background.default,

          "&::after": {
            zIndex: -1,
            content: "''",
            position: "absolute",
            width: "100%",
            height: "100%",
            background: theme.palette.backgroundAlpha.main,
          },
        },
      }),
}));
